module.exports = __webpack_public_path__ + "static/img2-257d1c49bc96a45ed698e7140ec23029.jpg";